import * as ex from "excalibur";
import { Resources } from "../Resources";
import { Player } from "../player";
import { Grandpa } from "../actors/characters/grandpa";

import { goToScene } from "../main";
import Computer from "../actors/computer";
import AddHiveMenu from "../ui/addHiveMenu";
import HtmlHud from "../ui/htmlHud";
import { hiveState, inventoryState } from "../state/stateManager";
import { Hive } from "../actors/hive";
import { getZeal, sendAlert } from "../utils";

export class Back40 extends ex.Scene {
  constructor() {
    super();
    const player = new Player(9 * 16, 15 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 3;
    let notice = new ex.Actor({
      pos: new ex.Vector(20 * 16, 7 * 16),
      height: 24,
      width: 100,
      color: ex.Color.fromHex("#80530f"),
    });
    const grandpa = new Grandpa(11 * 16, 7 * 16);
    this.grandpa = grandpa;
    grandpa.z = 2;
    this.computerCollision = false;
    this.addingHive = false;
  }
  onInitialize(engine) {
    Resources.Back40Map.addToScene(this);

    this.player.lastDir = "up";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);

    // this.player = Resources.HouseMap.getObjectsByName("player");

    // this.camera.strategy.lockToActor(this.player);
    this.door = new ex.Trigger({
      pos: new ex.Vector(7 * 16, 20 * 16),
      width: 120,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("home");
      },
    });
    this.add(this.door);
  }
  onDeactivate() {
    this.killHives();
    this.hud.cancelHud();
    if (this.swarmCheckTimer) {
      this.stopSwarmTimer();
    }
  }
  killHives() {
    this.hiveActors.forEach((h) => {
      h.kill();
    });
  }
  removeActive() {
    console.log("removing activeHive should not open: ", this.activeHive);
    this.activeHive = null;
  }
  setActive(hive) {
    console.log("inside setActive: ", hive);
    this.activeHive = hive;
    console.log("active: ", this);
  }
  onActivate(data) {
    this.addingHive = false;
    this.hud = new HtmlHud();
    Resources.BeeSounds.stop();
    this.hives = hiveState.getHives();
    console.log("getting ready to add hives: ", this.hives);
    this.hiveActors = [];
    for (let i = 0; i < this.hives.length; i++) {
      if (this.hives[i].position.yard == "back40") {
        let ho = new Hive(
          this.hives[i].position.x,
          this.hives[i].position.y,
          this.hives[i],
          this
        );
        this.add(ho);
        this.hiveActors.push(ho);
      }
    }
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    } else {
      this.player.pos = new ex.Vector(9 * 16, 17 * 16);
    }
    this.swarmCheck();
    this.startSwarmTimer();
  }
  swarmCheck() {
    console.log("inside swarmCheck");
    let hives = hiveState.getHives();
    hives.forEach((hi) => {
      if (hi.notes !== undefined && hi.notes !== null && hi.notes.length > 0) {
        //have swarm
        console.log("have swarm swarmCheck");
        if (hi.position.yard == "home") {
          //sendSwarm
          console.log("sending swarm: swarmCheck");
          hi.notes.splice(0, 1);
          this.hiveActors.forEach((ha) => {
            if (ha.birth == hi.birth) {
              console.log("calling swarm from hiveactors swarmCheck");
              sendAlert(`${hi.id} Swarmed!`);
              ha.swarm();
            }
          });
        }
      }
    });
  }
  startSwarmTimer() {
    this.swarmCheckTimer = setInterval(() => {
      this.swarmCheck();
    }, 10000);
  }
  stopSwarmTimer() {
    clearInterval(this.swarmCheckTimer);
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(ex.Keys.Enter)) {
      if (this.addingHive) {
        //add hive to this spot
        let xSpot = (this.player.pos.x + 8) / 16;
        let ySpot = (this.player.pos.y + 8) / 16;
        console.log(
          "addHive to this spot: x: ",
          xSpot,
          " y: ",
          ySpot,
          " playerPos: ",
          this.player.pos
        );
        goToScene("addHive", { x: xSpot, y: ySpot, yard: "back40" });
      }
    }
    if (this.engine.input.keyboard.wasPressed(ex.Keys.S)) {
      if (this.activeHive !== null && !this.addingHive) {
        console.log("setting lastSmoked");
        let hives = hiveState.getHives();
        hives.forEach((hi, i) => {
          if (hi.birth === this.activeHive.birth) {
            hi.lastSmoked = new Date().getTime();
          }
        });
        hiveState.setHives(hives);
      }
      switch (this.player.lastDir) {
        case "up":
          this.player.doAnim("up-smoke");
          break;
        case "down":
          this.player.doAnim("down-smoke");
          break;
        case "left":
          this.player.doAnim("left-smoke");
          break;
        case "right":
          this.player.doAnim("right-smoke");
          break;
        default:
          break;
      }
    }
    if (this.engine.input.keyboard.wasPressed(ex.Keys.F)) {
      if (this.activeHive !== null && !this.addingHive) {
        const inventory = inventoryState.getInventory();
        console.log("feeding");

        if (inventory.sugar >= 2) {
          console.log("hive from state : ", this.activeHive);
          let foodFrames = this.activeHive.foodFrames;
          foodFrames.count = foodFrames.count + 0.2;
          let hives = hiveState.getHives();
          hives.forEach((hive, i) => {
            if (hive.birth == this.activeHive.birth) {
              console.log("got hive");
              hive.foodFrames = foodFrames;
            }
          });
          inventory.sugar = inventory.sugar - 2;
          inventoryState.setInventory(inventory);
          hiveState.setHives(hives);
          Resources.Feed.play();
          sendAlert("Fed 1lb of Syrup!");
        } else {
          sendAlert("Not Enough Supply", () => {});
        }
      }
    }
    if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
      if (this.activeHive == null) {
        this.addingHive = true;
        this.addHiveMenu = new AddHiveMenu();
      } else {
        //check zeal
        if (getZeal()) {
          let indication = document.getElementById("hive-indication");
          indication.classList.remove("active");
          indication.style.display = "none";
          this.hud.cancelHud();
          //get updated hivestats to send to hivemenu
          let hives = hiveState.getHives();
          hives.forEach((hi) => {
            if (hi.birth === this.activeHive.birth) {
              this.activeHive = hi;
            }
          });
          goToScene("hiveMenu", this.activeHive);
        } else {
          Resources.Error.play();
          sendAlert("Over Sting Tolerance. Not Enough Zeal.");
        }
      }
    }
  }
}
